export default "assets/images/icons/fleche-6c205703.svg";